const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Mobile/MobileHome');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class MobileHome extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				gravity="center_horizontal"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("Header")}
					height="226"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="30,31,30,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Header}>
					<ImageView
						id={this.id("Group_5")}
						height="33"
						width="match_parent"
						margin="10,0,10,0"
						imageUrl="group549"
						style={this.style_Group_5} />
					<TextView
						id={this.id("Register")}
						height="25"
						width="match_parent"
						margin="0,44,0,0"
						text={this.STR.Register1}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Register} />
					<TextView
						id={this.id("Forum")}
						height="25"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Forum2}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Forum} />
				</LinearLayout>
				<LinearLayout
					id={this.id("Group_2")}
					height="1274"
					width="300"
					orientation="vertical"
					margin="0,10,0,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Group_2}>
					<ImageView
						id={this.id("Hero")}
						height="160"
						width="match_parent"
						margin="10,0,0,0"
						imageUrl="hero51"
						style={this.style_Hero} />
					<TextView
						id={this.id("Build_real_products")}
						height="80"
						width="match_parent"
						margin="0,35,0,0"
						text={this.STR.Build_real_products4}
						textSize={FontSize.A_32}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="40px"
						gravity="left"
						style={this.style_Build_real_products} />
					<TextView
						id={this.id("In_the_process_of_cr")}
						height="210"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.In_the_process_of_cr5}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_BOOK}
						lineHeight="28px"
						gravity="left"
						style={this.style_In_the_process_of_cr} />
					<TextView
						id={this.id("Story_of_1B_txns")}
						height="42"
						width="match_parent"
						margin="0,33,0,0"
						text={this.STR.Story_of_1B_txns6}
						textSize={FontSize.A_32}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="42px"
						gravity="left"
						style={this.style_Story_of_1B_txns} />
					<TextView
						id={this.id("Our_engineering_adva")}
						height="75"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Our_engineering_adva7}
						textSize={FontSize.A_16}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="24px"
						gravity="left"
						style={this.style_Our_engineering_adva} />
					<TextView
						id={this.id("Know_how")}
						height="25"
						width="102"
						margin="0,20,0,0"
						text={this.STR.Know_how8}
						textSize={FontSize.A_18}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_HEAVY}
						gravity="left"
						style={this.style_Know_how} />
					<LinearLayout
						id={this.id("Line")}
						height="3"
						width="match_parent"
						background={Color.A__FFD7D7D7}
						stroke="4,#ff0000"
						margin="0,30,0,0"
						cornerRadius="0"
						style={this.style_Line} />
					<TextView
						id={this.id("School_of_FP")}
						height="42"
						width="match_parent"
						margin="0,43,0,0"
						text={this.STR.School_of_FP9}
						textSize={FontSize.A_32}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="42px"
						gravity="left"
						style={this.style_School_of_FP} />
					<TextView
						id={this.id("Breaking_the_myth_th")}
						height="75"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Breaking_the_myth_th10}
						textSize={FontSize.A_16}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="24px"
						gravity="left"
						style={this.style_Breaking_the_myth_th} />
					<TextView
						id={this.id("Get_Started")}
						height="25"
						width="103"
						margin="0,20,0,0"
						text={this.STR.Get_Started3}
						textSize={FontSize.A_18}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_HEAVY}
						gravity="left"
						style={this.style_Get_Started} />
					<LinearLayout
						id={this.id("Line100000000ø")}
						height="3"
						width="match_parent"
						background={Color.A__FFD7D7D7}
						stroke="4,#ff0000"
						margin="0,30,0,0"
						cornerRadius="0"
						style={this.style_Line100000000ø} />
					<TextView
						id={this.id("Foundation")}
						height="42"
						width="match_parent"
						margin="0,43,0,0"
						text={this.STR.Foundation11}
						textSize={FontSize.A_32}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="42px"
						gravity="left"
						style={this.style_Foundation} />
					<TextView
						id={this.id("Derived_from_the_mat")}
						height="75"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Derived_from_the_mat12}
						textSize={FontSize.A_16}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="24px"
						gravity="left"
						style={this.style_Derived_from_the_mat} />
					<TextView
						id={this.id("Coming_soon")}
						height="25"
						width="119"
						margin="0,20,0,0"
						text={this.STR.Coming_soon13}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_HEAVY}
						gravity="left"
						style={this.style_Coming_soon} />
					<LinearLayout
						id={this.id("Rectangle")}
						height="66"
						width="match_parent"
						background={Color.A__FFFFFFFF}
						cornerRadius="0"
						style={this.style_Rectangle} />
				</LinearLayout>
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = MobileHome;



// WEBPACK FOOTER //
// ./views/Mobile/MobileHome.js